var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
export var SeatMapKey = function (_a) {
    var computedSeatMap = _a.computedSeatMap;
    var _b = useState([]), uniquePriceBands = _b[0], setUniquePriceBands = _b[1];
    useEffect(function () {
        if (computedSeatMap) {
            var seatmap = Object.values(computedSeatMap);
            var seatmapOrdered = seatmap.sort(function (a, b) { return (a.priceBand.color > b.priceBand.color) ? 1 : -1; });
            var allPriceBands = [];
            if (seatmapOrdered.length) {
                allPriceBands.push(seatmap[0]);
            }
            if (seatmapOrdered.length > 10 && allPriceBands.length > 0) {
                var currentArrayIndex = 0;
                for (var i = 0; i < seatmapOrdered.length; i++) {
                    if (allPriceBands[currentArrayIndex].priceBand.color != seatmap[i].priceBand.color) {
                        allPriceBands.push(seatmap[i]);
                        currentArrayIndex = currentArrayIndex + 1;
                    }
                }
            }
            setUniquePriceBands(allPriceBands);
        }
    }, [computedSeatMap]);
    return (_jsx(_Fragment, { children: _jsx("section", { children: _jsxs("div", __assign({ className: "seatmap-key-wrapper" }, { children: [_jsxs("div", __assign({ className: "seatmap-key-item" }, { children: [_jsx("div", { className: "seating-map-key selected-key-color" }), _jsx("div", __assign({ className: "seatmap-key-title" }, { children: "Selected" }))] })), _jsxs("div", __assign({ className: "seatmap-key-item" }, { children: [_jsx("div", { className: "seating-map-key unavailable-key-color" }), _jsx("div", __assign({ className: "seatmap-key-title" }, { children: "Unavailable" }))] })), uniquePriceBands ? uniquePriceBands.map(function (item, index) {
                        return (_jsxs("div", __assign({ className: "seatmap-key-item" }, { children: [_jsx("div", { className: "seating-map-key", "data-testid": "seatmap-key-priceband-dot-".concat(index), style: { backgroundColor: item.priceBand.color } }), _jsx("div", __assign({ className: "seatmap-key-title", "data-testid": "seatmap-key-priceband-title-".concat(index) }, { children: item.priceBand.title }))] })));
                    }) : null] })) }) }));
};
export default SeatMapKey;
